// flow weak

import React, {
  PureComponent
}                         from 'react';
import PropTypes          from 'prop-types';
import styles                 from './style';
import {
  defaultOptions,
  checkStatus,
  parseJSON,
  getLocationOrigin
}                     from '../../../../services/fetchTools';
import {Link} from 'react-router-dom';
import FlatButton from 'material-ui/FlatButton';
import styled from 'styled-components';
import { Spinner } from 'react-activity';
import Dialog from 'material-ui/Dialog';
import moment from 'moment';
import DatePicker from 'react-datepicker';

class ExpenseRecords extends PureComponent {
  static propTypes = {
    actions: PropTypes.shape({
      enterPage: PropTypes.func,
      leavePage: PropTypes.func
    })
  };

  constructor(props) {
    super(props);
    this.state = {
      venue: props.match.params.id,
      date: moment(),
      expense_data: [],
      date_changed: false,
      dialog_delete: false,
      record_id:'',
      deleted: false,
      success: false
     
    };
    this.handleSelection = this.handleSelection.bind(this);
    this.handleDate = this.handleDate.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
    this.deleteExpense = this.deleteExpense.bind(this);
  }

  componentWillMount() {
    const { actions: { enterPage } } = this.props;
    enterPage('Home');
  }

  componentDidMount() {
  }

  componentWillUnmount() {
    const { actions: { leavePage } } = this.props;
    leavePage('Home');
  }

  getExpenseRecords() {
    const date = this.state.date.format('YYYY-MM-DD')
    const url = `${getLocationOrigin()}/cm/get_expense_records/?venue=${this.state.venue}&date=${date}`;
    const options = {...defaultOptions};

    return fetch(url, options)
       .then(checkStatus)
       .then(parseJSON)
       .then(data => {
            this.setState({expense_data:data.result,success:data.success,date_changed:false,deleted:false})
           // alert("fix");
       }).catch(error => error);
  }

  deleteExpense() {
    const url = `${getLocationOrigin()}/cm/delete_expense_record/`;
    const options = {...defaultOptions};
    
    options['method'] = 'post';
    options['headers'] = {'content-type': 'application/json'}
    options['body'] = JSON.stringify({
                        'record_id':this.state.record_id
                      });

    return fetch(url, options)
      .then(checkStatus)
      .then(parseJSON)
      .then(response =>{       
          console.log(response.message)
          console.log('success')                           
          alert(response.message);
          this.setState({deleted:true,dialog_delete:false})
          this.renderExpense()
          })
      .catch(error => {
        console.log('error')
        console.log(error);
        alert(error.message);
      });
    }

  handleSelection(event){
    const name = event.target.name
    if(name == 'expense'){
      this.setState({expense:true,revenue:false})
    }
    else if(name == 'revenue'){
      this.setState({revenue:true,expense:false})
    }
  }

  handleDate(date){
    this.setState({date:date,date_changed:true});
    this.renderExpense();
  }

  handleDelete(event){
    const id = event.target.value;
    this.setState({record_id:id,dialog_delete:true})
  }

  handleClose = () => {
    this.setState({dialog_delete:false});
  }

  handleOpen=()=>{
    this.setState({dialog_delete:true})
  }


  renderExpense(){
    if((this.state.expense_data.length == 0 && !this.state.success)|| this.state.date_changed || this.state.deleted){
      this.getExpenseRecords()
    }
    var header = []
    if(this.state.expense_data.length > 0){
      header = Object.keys(this.state.expense_data[0]).slice(1).map(each=>each.replace('_',' '))
      header = header.map(each => each.charAt(0).toUpperCase() + each.slice(1))
       
    }
    return(
      <div className='col-md-12 table_container1' style={styles.table}>
        <div className="heading heading2 left" style={styles.header}>Expense Details</div> 
        <div style={{display:'flex',margin:'1%'}}>
          <div> Date - </div>
          <DatePicker selected={this.state.date} onChange={this.handleDate}/>
        </div>
        <table className="table_plain">
          { this.state.expense_data.length > 0 &&
          <tr> 
            { 
              header.map((head)=>
                <th>{head}</th>
                )
             }
             <th> Action </th>
          </tr>
          }
          
            { this.state.expense_data && this.state.expense_data.length > 0 && !this.state.date_changed ?
              this.state.expense_data.map((data)=>
                <tr>
                 { Object.keys(this.state.expense_data[0]).slice(1).map((index)=>
                    <td>{data[index]}</td>
                    )
                  }

                  <td> <button className='button1' onClick={this.handleDelete} value={data['id']}>Delete</button> </td>
                </tr>
                )
              :
              this.state.success && this.state.expense_data.length == 0?
              <div style={{height:500}}>
                <div style={{  position: 'absolute',top: '50%',left: '50%',width: '100%',height: '100%'}}> No Data Available</div>
              </div>
              :
              <div style={{height:500}}>
                <div style={{  position: 'absolute',top: '50%',left: '50%',width: '100%',height: '100%'}}> <Spinner size="50" /></div>
              </div>
            }
        </table>
      </div>
      )
  }

  
  render() {

    const actions = [
        <FlatButton
          label="Cancel"
          primary={true}
          onClick={this.handleClose}
        />,
        <FlatButton
          label="Submit"
          primary={true}
          onClick={this.deleteExpense}
        />,
      ];
    
    return(
      <div style={styles.container}>
        
          <div className='col-md-12' style={{width:'100%'}}>
            <div className='col-md-12' style={{padding:'0px'}}>
              <button className='button1' style={{marginRight:'1%'}} onClick={()=>{this.props.history.goBack();}}> Back</button>
              
            </div>
              
            <div className='col-md-12'>
              {this.renderExpense()}
            </div>   
          </div>

          {
            this.state.dialog_delete &&
              <Dialog
                    actions={actions}
                    modal={false}
                    open={this.state.dialog_delete}
                    onRequestClose={this.handleClose}
                    autoDetectWindowHeight={true}
                    autoScrollBodyContent={true}
                  >
                <div >
                  <div style={styles.main_header,{justifyContent:'center'}} className="col-md-12 label_blue_1">
                    <h4 style={{textAlign:'center'}}> Delete Record </h4>
                  </div>
                  <div className='col-md-12' style={{marginTop:'2%'}}>Are you sure you want to delete ? </div>
                </div>
              </Dialog>
          }
        
      </div>
    );
  }
}

export default ExpenseRecords;



// WEBPACK FOOTER //
// ./src/app/views/centerportal/crud/expenseRecords/ExpenseRecords.js